// 9fbef606107a605d69c0edbcd8029e5d
import get from 'lodash/get';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
} from '@tcp/core/src/utils/labels/globalActions.labels';
import {
  GLOBAL_SMS_SIGN_UP_LABELS,
  GlobalSmsSignUpLabels,
} from '@tcp/core/src/utils/labels/globalSmsSignUp.labels';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import SMSSubscriptionSaga from './SubscriptionSMS.saga';
import SMSSubscriptionReducer from './SubscriptionSMS.reducer';
import { submitSmsSubscription } from './SubscriptionSMS.action';

import SubscriptionSMSView from '../views';

const splitHeading = (stringVal = '') => {
  const [heading1, heading2] = stringVal.split('##').map((str) => str.trim());
  return {
    heading1,
    heading2,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    subscriptionSmsSubmit: (payload) => {
      dispatch(submitSmsSubscription(payload));
    },
  };
};

const mapStateToProps = (state) => {
  const submitTitle = renderLabel(
    getLabelFromCopyOrFromTranslation(`${GLOBAL_ACTIONS_LABELS}.lbl_submit`, GlobalActionsLabels),
    'lbl_submit'
  );
  const smsPlaceHolderText = renderLabel(
    getLabelFromCopyOrFromTranslation(
      `${GLOBAL_SMS_SIGN_UP_LABELS}.lbl_combined_sms_placeholder`,
      GlobalSmsSignUpLabels
    ),
    'lbl_combined_sms_placeholder'
  );
  const validationErrorLabel = getDynamicLabelValues(
    `dynamic.global_d.lbl_sms_errorValidationLabel`
  );

  const subscribedErrorLabel = getDynamicLabelValues(
    `dynamic.global_d.lbl_sms_validationErrorLabel`
  );
  const submissionLabel = getDynamicLabelValues(`dynamic.global_d.lbl_sms_submission_message`);
  const titleFullText = getDynamicLabelValues('dynamic.home.lbl_sms_subscription');
  const tabToJoinCTA = getDynamicLabelValues('dynamic.global_d.lbl_sms_button_text');
  const { heading1, heading2 } = splitHeading(titleFullText);

  const richText = get(state, 'Footer.smsSignupBtn.richText.text', '');
  const smsDisclaimer = { richText };

  const SMSNumber = getDynamicLabelValues(`dynamic.global_d.lbl_footer_SMS_textNumber`);
  const SMSBody = getDynamicLabelValues(`dynamic.global_d.lbl_footer_SMS_bodyText`);

  const smsTemplate = `sms:${SMSNumber}?&body=${SMSBody}`;

  const { subscription: subscriptionStatus = {} } = state.hpSubscriptionSms || {};

  return {
    heading1,
    heading2,
    submitTitle,
    smsTemplate,
    tabToJoinCTA,
    smsDisclaimer,
    submissionLabel,
    subscriptionStatus,
    smsPlaceHolderText,
    validationErrorLabel,
    subscribedErrorLabel,
  };
};

const withReducer = withDynamicReducer({
  key: 'hpSubscriptionSms',
  reducer: SMSSubscriptionReducer,
});
const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withSaga = withDynamicSaga({ key: 'hpSubscriptionSms', saga: SMSSubscriptionSaga });

export default compose(withReducer, withSaga, withConnect)(SubscriptionSMSView);
